import type { FC, ReactNode } from 'react';
import { Avatar, Col, Divider, Grid, Row, Typography } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

export interface PreferenceRowProps {
    control: ReactNode;
    description: ReactNode;
    divided?: boolean;
    icon: ReactNode;
    label: ReactNode;
}

const PreferenceRow: FC<PreferenceRowProps> = ({ control, description, divided = false, icon, label }) => {
    const { token } = useAntDesignTheme();
    const screens = Grid.useBreakpoint();
    const stacked = !screens.md;

    return (
        <>
            {divided ? <Divider style={{ margin: 0 }} /> : null}
            <Row align={stacked ? 'top' : 'middle'} gutter={[16, 16]} style={{ padding: '1rem' }} wrap={stacked}>
                <Col flex='1 1 0' style={{ minWidth: 0 }}>
                    <div style={{ alignItems: 'flex-start', display: 'flex', gap: '0.75rem', minWidth: 0 }}>
                        <Avatar
                            aria-hidden='true'
                            icon={icon}
                            shape='square'
                            size={28}
                            style={{
                                background: token.colorFillQuaternary,
                                border: `1px solid ${token.colorBorderSecondary}`,
                                color: token.colorTextSecondary,
                                flex: 'none',
                            }}
                        />
                        <div style={{ minWidth: 0 }}>
                            <Typography.Title level={5} style={{ marginBottom: '0.125rem' }}>
                                {label}
                            </Typography.Title>
                            <Typography.Paragraph style={{ color: token.colorTextTertiary, marginBottom: 0 }}>
                                {description}
                            </Typography.Paragraph>
                        </div>
                    </div>
                </Col>
                <Col flex={stacked ? '1 0 100%' : '0 0 13rem'} style={{ marginLeft: stacked ? 0 : 'auto' }}>
                    {control}
                </Col>
            </Row>
        </>
    );
};

export default PreferenceRow;
